import _ from "lodash";

import { useSidebarContext } from "@/contexts/SidebarContext";
import useGetCachesHandler from "@/hooks/useGetCachesHandler";

const useAdaFieldsHandler = () => {
  const { path } = useSidebarContext();
  const { getPriorityFields } = useGetCachesHandler();
  const [category, subCategory, crossProduct1] = path;

  const addPriorityFields = async (fields) => {
    const priorityFields = await getPriorityFields();
    const priorities = _.get(priorityFields, path) || [];
    return fields.map((field) => ({
      ...field,
      // create new priority field and assign boolean value
      priority: priorities.includes(field.name),
    }));
  };

  const getAdaFields = async (template) => {
    if (crossProduct1) {
      let freshFields = _.cloneDeep(_.get(template, [category, subCategory]));
      // if there are dotted fields
      const dottedFieldName = path.slice(1).join(".");
      if (template[category][dottedFieldName]) {
        const dottedFields = template[category][dottedFieldName];
        // loop over dotted fields, find coresponding fresh field, update fresh field with dotted field values
        dottedFields.forEach((dottedField) => {
          freshFields.forEach((freshField, index) => {
            if (freshField["name"] == dottedField["name"]) {
              freshFields[index] = dottedField;
            }
          });
        });
      }

      freshFields = await addPriorityFields(freshFields);

      return {
        subCategoryName: dottedFieldName,
        fields: freshFields,
      };
    } else {
      // simple case (no cross product)
      let fields = _.get(template, path);
      fields = await addPriorityFields(fields);
      return {
        subCategoryName: subCategory,
        fields,
      };
    }
  };

  const handleMultipleTemplateChanges = (template, index, obj) => {
    const subCategoryName = crossProduct1
      ? path.slice(1).join(".")
      : subCategory;

    const templateWithNewFields = { ...template };
    for (const key in obj) {
      templateWithNewFields[category][subCategoryName][index][key] = obj[key];
    }
    return templateWithNewFields;
  };

  return { getAdaFields, handleMultipleTemplateChanges };
};

export default useAdaFieldsHandler;
